import React from "react";
import PropTypes from "prop-types";
import { Card, Typography, List, Tag } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const ListCard = ({ title, items }) => {
  return (
    <Card style={{ borderRadius: 12 }}>
      <Title level={5} style={{ marginBottom: 16 }}>
        {title}
      </Title>

      <List
        itemLayout="horizontal"
        dataSource={items}
        split={false}
        renderItem={(item) => (
          <List.Item style={{ padding: "12px 0" }}>
            <List.Item.Meta
              title={<Text>{item.address}</Text>}
              description={
                <span style={{ fontSize: 12, color: "#888" }}>
                  <ClockCircleOutlined style={{ marginRight: 4 }} />
                  {item.time}
                </span>
              }
            />
            <Tag color={item.color}>{item.status}</Tag>
          </List.Item>
        )}
      />
    </Card>
  );
};

ListCard.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      address: PropTypes.string.isRequired,
      time: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      color: PropTypes.string,
    })
  ).isRequired,
};

export default ListCard;
